import React, { useState, useEffect, useMemo } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { Tile } from '@thd-olt-component-react/tile';
import { SettingsForm } from '@thd-olt-component-react/list-forms';
import { withOverlay } from '@thd-olt-component-react/component-design-patterns';
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './list-tile.module.scss';
import { Preview } from './preview/Preview';
import { ListTilePlaceholder } from './placeholder/Placeholder';
import { dataModel } from './dataModel';
import { propTypes, defaultProps } from './propTypes';

const ListTileDesktop = ({
  listId, data, onClick, onDelete, width, height
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('list-tile-desktop.ready'); }, []);
  const [toggleOpen, setToggleOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);
  const { data: listData, loading, error } = useDataModel('list', {
    variables: { id: listId },
    skip: !!data,
    context: { withAuth: true }
  });

  const { list = data } = listData || {};

  const onListTileMouseEnter = () => setIsHovered(true);

  const onListTileMouseLeave = () => setIsHovered(false);

  const onDeleteConfirmation = () => {
    if (onDelete) {
      onDelete({ listId });
    }
  };

  const handlePreviewClick = () => {
    if (onClick) {
      onClick({ listId });
    }
  };

  const onButtonEnter = () => {
    setButtonHovered(true);
  };

  const onButtonLeave = () => {
    setButtonHovered(false);
  };
  const onToggle = (value) => {
    setToggleOpen(value);
  };

  const SettingsFormWithOverlay = useMemo(() => withOverlay(
    SettingsForm,
    {
      transparent: true,
      dark: true,
      outline: true,
      className: styles['settings-button'],
      onMouseEnter: onButtonEnter,
      onMouseLeave: onButtonLeave
    },
    {
      fit: true,
      className: styles['list-tile__overlay'],
      scrollable: true,
      modalClass: styles['list-tile__modal'],
      closeButton: false,
      onToggle
    }
  ), []);

  if (!list && loading) return <ListTilePlaceholder />;
  if (!list || !list?.url) return null;

  return (
    <>
      <Tile
        className={styles['list-tile']}
        data-testid="list-tile-container"
        onMouseEnter={onListTileMouseEnter}
        onMouseLeave={onListTileMouseLeave}
        width={width}
        height={height}
      >
        <Preview url={list.url} onClick={handlePreviewClick} thumbnails={list.images} />
        <div className={styles['list-tile__content']}>
          <div className={styles['list-tile__text-wrapper']}>
            <div className={styles['list-tile__name']}>
              <a title={list?.name} href={list.url}>
                {list.name}
              </a>
            </div>
            <div className={styles['list-tile__item-count']}>
              {list?.itemCount || 0}
              {list?.itemCount === 1 ? ' item' : ' items'}
            </div>
          </div>
          <div className={styles['list-tile__details']}>
            <SettingsFormWithOverlay
              list={list}
              onDelete={onDeleteConfirmation}
            >
              <Image
                width={24}
                height={24}
                asset={(buttonHovered || toggleOpen)
                  ? 'settings-orange.svg'
                  : 'settings-gray.svg'}
                alt="Settings"
              />
            </SettingsFormWithOverlay>
          </div>
        </div>
      </Tile>
    </>
  );
};

ListTileDesktop.propTypes = propTypes;

ListTileDesktop.defaultProps = defaultProps;

ListTileDesktop.displayName = 'ListTileDesktop';

ListTileDesktop.dataModel = dataModel;

export { ListTileDesktop };